import axios from 'axios'

const listToMap = (list , keyProp ,valueProp) => { //處理片語對應陣列轉為 Map 物件
   const map= {};
   if(list && list.length > 0){
    list.forEach((it) => {
        map[it[keyProp]] = it[valueProp];
    });
   }
   return map;
}
const baseApiUrl = window.ROE_APP_API || window.BaseUrl.VUE_APP_API;
const baseQuotationURL = `${baseApiUrl}/Quotation`;
const getPhrase = i18nFunc => {//取的語系對應片語
  const $t = i18nFunc;
  const factoryMap= listToMap($t('factoryListForPurchase'), 'factoryId' ,'factoryCaption');
  const requestTypeMap= listToMap($t('requestTypeList'), 'requestTypeId' ,'requestTypeCaption');
  const requestWayMap= listToMap($t('requestWayList'), 'requestWayId' ,'requestWayCaption');
  const caseClosedMap= listToMap($t('caseClosedList'), 'caseClosedId' ,'caseClosedCaption');
  const notifySupervisorMap= listToMap($t('notifySupervisorList'), 'notifySupervisorId' ,'notifySupervisorCaption');
  return {factoryMap,requestTypeMap,requestWayMap,caseClosedMap,notifySupervisorMap};      
}
export default {
    // state 屬於模組區域變數
    // actions, mutations, getters 是屬於全域變數
  namespaced: true,     // actions, mutations, getters 是屬於區域變數
  state: {
    purchaseSearchObj: {rows: [] , filter: {pageSize: 10 , pageIndex: 1} ,totalCount: 0 }, //招標及報價查詢結果+查詢條件
    procurementOfficerList:[] //採購人員清單
  },
  actions: {
    searchPurchase(context, parameter) {
        const url = `${baseQuotationURL}/PurchaseSearchRequestForQuotePageAsync`               
        const $t = parameter.func; //多語系處理函數
        const $fixDate = parameter.fixDate;        
        parameter.func =null;        
        const filter = context.getters.purchaseSearchObj.filter;
        let params = {...filter}
        Object.assign(params, parameter);
        //--修正查詢參數中 StartDateBegin StartDateEnd  DeadlineBegin DeadlineEnd 若為空字串轉為 null
        const fixQry = ['StartDateBegin','StartDateEnd','DeadlineBegin','DeadlineEnd'];
        fixQry.forEach(it=>{
          if(params[it] === ''){
            params[it] = null;
          }
        });         
        context.commit('LOADING', true, {root: true});
               
        axios.post(url, params).then((response) => {
            const {factoryMap,requestTypeMap,requestWayMap,caseClosedMap,notifySupervisorMap} = getPhrase($t);
            const rows = response.data.rows;
            const resultList = [];            
            rows.map(item => {
                let factory = factoryMap[item.factoryId];                
                let category = requestTypeMap[item.requestType];
                let requestWay = item.requestWay;
                if(item.requestWay !== '1') {
                    requestWay = '2';
                }
                let wayTxt = requestWayMap[requestWay];
                let chkCaseClosed = item.caseClosed;                
                let closeTxt = caseClosedMap[item.caseClosed];
                if('Y' === chkCaseClosed && item.settingCaseClosedUser){                   
                   if(closeTxt === '已結案(Y)'){
                      //closeTxt ='指定結案(Y)';
                      closeTxt = '指定結案(Y)[' + item.settingCaseClosedUserName + ']';
                   }else{
                      closeTxt ='Setting CaseClosed';
                   }
                }
                if(!closeTxt){
                  if('X' === item.caseClosed){
                    closeTxt = '作廢';
                  }else{
                    closeTxt = item.caseClosed;
                  }                  
                }
                let notifyText = notifySupervisorMap[item.notifySupervisor];   
                const quotationDate = $fixDate(item.quotationDate);
                const startDate = $fixDate(item.startDate);
                const deadline = $fixDate(item.deadline);
                let data = {
                    ...item,
                    factoryId: factory,
                    requestType: category,
                    requestWay: wayTxt,
                    caseClosedCode: item.caseClosed,
                    caseClosed: closeTxt,
                    notifySupervisor:notifyText,
                    startDate: startDate,
                    deadline: deadline,
                    quotationDate: quotationDate
                }                
                resultList.push(data);
            })
            let obj = {};
            obj.rows = resultList;
            obj.filter = params;
            obj.totalCount = response.data.totalCount;
            context.commit('ChangePurchaseSearchResult', obj);
            context.commit('LOADING', false, {root: true});
            // this.updateLoading(false)
        }) 
    },
    getProcurementOfficers(context) {      
      //let vm =this._vm;
      //const baseApiUrl = vm.$baseApiUrl;
      const url = `${baseQuotationURL}/GetProcurementOfficers`
      context.commit('LOADING', true, {root: true});             
      axios.get(url, {}).then((response) => {
        const rows = response.data;
        const resultList = [];
        rows.map(item => {
          resultList.push(item);//{id: 'Jason',text: 'Jason'}
        });
        context.commit('ProcurementOfficersResult', resultList);
        context.commit('LOADING', false, {root: true});
      }) 
    }
  },
  mutations: {
    // CLASS(state, payload) {
    //     state.categories = payload;
    // },
    ChangePurchaseSearchResult(state, payload) {//存入 招標及報價查詢結果
        let obj = state.purchaseSearchObj;
        obj.rows = payload.rows;
        obj.filter = payload.filter;
        obj.totalCount = payload.totalCount;
    },
    ProcurementOfficersResult(state, payload) {//存入 採購人員清單
        state.procurementOfficerList = payload;
    }
  },
  getters: {
    purchaseSearchObj: state => state.purchaseSearchObj,
    procurementOfficerList: state => state.procurementOfficerList
  },
  
}